var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "person-spec-crud",
      attrs: { method: "POST", enctype: "multipart/form-data" }
    },
    [
      _vm.errors.length > 0
        ? _c("div", { staticClass: "errors mb-4" }, [
            _c(
              "ul",
              _vm._l(_vm.errors, function(error) {
                return _c("li", [
                  _vm._v(
                    "\n                " + _vm._s(error) + "\n            "
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("fieldset", [
        _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
          _c("div", { staticClass: "cell medium-6 large-5" }, [
            _c("fieldset", [
              _c("legend", [_vm._v("ATS Type")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.atsType,
                      expression: "atsType"
                    }
                  ],
                  staticClass: "personspec-dropdown",
                  attrs: {
                    disabled: _vm.isUsedByRequisition,
                    name: "ats_type"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.atsType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "agent" } }, [
                    _vm._v("Agent")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "leadership_and_support" } }, [
                    _vm._v("Leadership And Support")
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c("div", { staticClass: "cell medium-6 large-5" }, [
            _c("label", [_vm._v("Person Specification Title")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.personSpec.title,
                  expression: "personSpec.title"
                }
              ],
              attrs: {
                disabled: _vm.isUsedByRequisition,
                name: "title",
                type: "text",
                required: ""
              },
              domProps: { value: _vm.personSpec.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.personSpec, "title", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Business Unit")]),
              _vm._v(" "),
              _c("vue-select", {
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  label: "title",
                  options: _vm.companies
                },
                on: {
                  search: _vm.fetchCompanies,
                  input: function(company) {
                    _vm.businessLineId = null
                    _vm.businessLines = company.business_lines
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function(option) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(option.title) +
                            "\n                    "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.company,
                  callback: function($$v) {
                    _vm.company = $$v
                  },
                  expression: "company"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Line of Business")]),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  name: "business_line_id",
                  type: "hidden",
                  required: ""
                },
                domProps: { value: _vm.businessLineId }
              }),
              _vm._v(" "),
              _c("vue-select", {
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  label: "title",
                  reduce: function(businessLine) {
                    return businessLine.id
                  },
                  options: _vm.businessLines
                },
                model: {
                  value: _vm.businessLineId,
                  callback: function($$v) {
                    _vm.businessLineId = $$v
                  },
                  expression: "businessLineId"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Base Lines")]),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  name: "baseline_id",
                  type: "hidden",
                  required: ""
                },
                domProps: { value: _vm.baselineId }
              }),
              _vm._v(" "),
              _c("vue-select", {
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  label: "area",
                  reduce: function(baseline) {
                    return baseline.id
                  },
                  options: _vm.baselines
                },
                model: {
                  value: _vm.baselineId,
                  callback: function($$v) {
                    _vm.baselineId = $$v
                  },
                  expression: "baselineId"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Purpose of Role")]),
              _vm._v(" "),
              _vm.isUsedByRequisition
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.personSpec.purpose,
                        expression: "personSpec.purpose"
                      }
                    ],
                    attrs: {
                      disabled: _vm.isUsedByRequisition,
                      name: "purpose",
                      type: "text",
                      required: "",
                      rows: "5"
                    },
                    domProps: { value: _vm.personSpec.purpose },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.personSpec, "purpose", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isUsedByRequisition
                ? _c("RedactorControl", {
                    attrs: {
                      name: "purpose",
                      value: _vm.personSpec ? _vm.personSpec.purpose : "",
                      rows: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v("Competencies")]),
          _vm._v(" "),
          _c("Competencies", {
            attrs: {
              disabled: _vm.isUsedByRequisition,
              type: "knowledge",
              title: "Knowledge & Education",
              competencies: _vm.knowledgeCompetencies,
              "selected-preferred-ids": _vm.personSpec
                .preferred_knowledge_competencies
                ? _vm.personSpec.preferred_knowledge_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : [],
              "selected-essential-ids": _vm.personSpec
                .essential_knowledge_competencies
                ? _vm.personSpec.essential_knowledge_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : []
            }
          }),
          _vm._v(" "),
          _c("Competencies", {
            attrs: {
              disabled: _vm.isUsedByRequisition,
              type: "experience",
              title: "Experience",
              competencies: _vm.experienceCompetencies,
              "selected-preferred-ids": _vm.personSpec
                .preferred_experience_competencies
                ? _vm.personSpec.preferred_experience_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : [],
              "selected-essential-ids": _vm.personSpec
                .essential_experience_competencies
                ? _vm.personSpec.essential_experience_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : []
            }
          }),
          _vm._v(" "),
          _c("Competencies", {
            attrs: {
              disabled: _vm.isUsedByRequisition,
              type: "skill",
              title: "Skill",
              competencies: _vm.skillCompetencies,
              "selected-preferred-ids": _vm.personSpec
                .preferred_skill_competencies
                ? _vm.personSpec.preferred_skill_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : [],
              "selected-essential-ids": _vm.personSpec
                .essential_skill_competencies
                ? _vm.personSpec.essential_skill_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : []
            }
          }),
          _vm._v(" "),
          _c("Competencies", {
            attrs: {
              disabled: _vm.isUsedByRequisition,
              type: "attribute",
              title: "Attribute",
              competencies: _vm.attributeCompetencies,
              "selected-preferred-ids": _vm.personSpec
                .preferred_attribute_competencies
                ? _vm.personSpec.preferred_attribute_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : [],
              "selected-essential-ids": _vm.personSpec
                .essential_attribute_competencies
                ? _vm.personSpec.essential_attribute_competencies.map(function(
                    comp
                  ) {
                    return comp.id
                  })
                : []
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("fieldset", [
        _c("legend", [_vm._v("Languages")]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Languages")]),
              _vm._v(" "),
              _c("vue-select", {
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  label: "title",
                  reduce: function(language) {
                    return language.id
                  },
                  options: _vm.languages,
                  multiple: true
                },
                model: {
                  value: _vm.selectedLanguages,
                  callback: function($$v) {
                    _vm.selectedLanguages = $$v
                  },
                  expression: "selectedLanguages"
                }
              }),
              _vm._v(" "),
              _vm.selectedLanguages.length > 0
                ? [
                    _vm._l(_vm.selectedLanguages, function(id, index) {
                      return [
                        _c("input", {
                          attrs: {
                            name:
                              "person_specification_languages[" +
                              index +
                              "][language_id]",
                            type: "hidden"
                          },
                          domProps: { value: id }
                        })
                      ]
                    })
                  ]
                : _c("input", {
                    attrs: {
                      name: "person_specification_languages",
                      value: "",
                      type: "hidden"
                    }
                  })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("fieldset", [
        _c("legend", [_vm._v("Shift Info")]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
          _c("div", { staticClass: "cell medium-6 large-5" }, [
            _c("label", [_vm._v("Shift Type")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.personSpec.shift_type,
                    expression: "personSpec.shift_type"
                  }
                ],
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  name: "shift_type"
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.personSpec,
                      "shift_type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "day" } }, [
                  _vm._v("Day Shift")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "night" } }, [
                  _vm._v("Night Shift")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell medium-6 large-5" }, [
            _c("label", [_vm._v("Shift Service Area")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.personSpec.shift_service_area,
                    expression: "personSpec.shift_service_area"
                  }
                ],
                staticClass: "personspec-dropdown",
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  name: "shift_service_area"
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.personSpec,
                      "shift_service_area",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "America" } }, [
                  _vm._v("America")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "Australia" } }, [
                  _vm._v("Australia")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "Canada" } }, [
                  _vm._v("Canada")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "South Africa" } }, [
                  _vm._v("South Africa")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "UK" } }, [_vm._v("UK")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Shift Hours")]),
              _vm._v(" "),
              _vm.isUsedByRequisition
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.personSpec.shift_hours,
                        expression: "personSpec.shift_hours"
                      }
                    ],
                    attrs: {
                      disabled: _vm.isUsedByRequisition,
                      name: "shift_hours",
                      type: "text",
                      rows: "5"
                    },
                    domProps: { value: _vm.personSpec.shift_hours },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.personSpec,
                          "shift_hours",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isUsedByRequisition
                ? _c("RedactorControl", {
                    attrs: {
                      name: "shift_hours",
                      value: _vm.personSpec ? _vm.personSpec.shift_hours : "",
                      rows: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cell medium-6 large-5" },
            [
              _c("label", [_vm._v("Breaks & Lunch")]),
              _vm._v(" "),
              _vm.isUsedByRequisition
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.personSpec.breaks_and_lunch,
                        expression: "personSpec.breaks_and_lunch"
                      }
                    ],
                    attrs: {
                      disabled: _vm.isUsedByRequisition,
                      name: "breaks_and_lunch",
                      type: "text",
                      rows: "5"
                    },
                    domProps: { value: _vm.personSpec.breaks_and_lunch },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.personSpec,
                          "breaks_and_lunch",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isUsedByRequisition
                ? _c("RedactorControl", {
                    attrs: {
                      name: "breaks_and_lunch",
                      value: _vm.personSpec
                        ? _vm.personSpec.breaks_and_lunch
                        : "",
                      rows: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Employment Phases")]),
              _vm._v(" "),
              _c("employment-phases", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-employment-phases":
                    _vm.personSpec.employment_phase_specs || []
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Background Verification")]),
              _vm._v(" "),
              _c("background-verification-specs", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-background-verification-specs":
                    _vm.personSpec.background_verification_specs || [],
                  "i-facts-checks": _vm.iFactsChecks
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-10" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Skills Assessments")]),
              _vm._v(" "),
              _c("skill-assessment-specs", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-skill-assessment-specs":
                    _vm.personSpec.skill_assessment_specs || [],
                  "classmarker-assessments": _vm.classmarkerAssessments
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Killer Questions")]),
              _vm._v(" "),
              _c("killer-question-specs", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-killer-question-specs":
                    _vm.personSpec.killer_questions || []
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Client Original Brief")]),
              _vm._v(" "),
              _vm.clientBriefLink
                ? _c("label", [
                    _vm.clientBriefLink
                      ? _c("small", [
                          _vm._v("(Existing: "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.clientBriefLink
                              }
                            },
                            [_vm._v(_vm._s(_vm.clientBriefLink))]
                          ),
                          _vm._v(")")
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("FileInputControl", {
                attrs: {
                  name: "client_original_brief",
                  disabled: _vm.isUsedByRequisition
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Interview Questions")]),
              _vm._v(" "),
              _c("interview-questions", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-interview-questions":
                    _vm.personSpec.interview_questions || []
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
        _c("div", { staticClass: "cell medium-6 large-5" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Required Documents")]),
              _vm._v(" "),
              _c("required-documents", {
                attrs: {
                  disabled: _vm.isUsedByRequisition,
                  "default-required-documents":
                    _vm.personSpec.required_documents || [],
                  "qualification-levels": _vm.qualificationLevels
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.atsType == "leadership_and_support"
        ? _c("div", [
            _c("div", { staticClass: "form-control mt-3" }, [
              _c("label", [
                _vm._v(
                  "Do NOT send any communications to candidates (Recruiters will do the application process for candidates)"
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center yes-no-item" },
                  [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        name: "notification_disabled",
                        value: "1"
                      },
                      domProps: {
                        checked: _vm.personSpec.notification_disabled == 1
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n                        Yes\n                    "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center yes-no-item" },
                  [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        name: "notification_disabled",
                        value: "0"
                      },
                      domProps: {
                        checked: _vm.personSpec.notification_disabled == 0
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n                        No\n                    "
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        : _c("div", [
            _c("input", {
              attrs: {
                type: "hidden",
                value: "0",
                name: "notification_disabled"
              }
            })
          ]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "_csrfToken" },
        domProps: { value: _vm.csrfToken }
      }),
      _vm._v(" "),
      _vm.isUsedByRequisition
        ? [
            _c("p", [
              _vm._v(
                "You cannot modify this person specification because it is already used by a requisition. You can clone it instead and create a new version."
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button primary",
                attrs: { type: "submit", name: "clone", value: "1" }
              },
              [_vm._v("\n            Clone\n        ")]
            )
          ]
        : [
            _c(
              "button",
              { staticClass: "button btn-green", attrs: { type: "submit" } },
              [_vm._v("\n            Save  \n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button primary",
                attrs: { type: "submit", name: "save_progress", value: "1" }
              },
              [_vm._v("\n            Save Progress\n        ")]
            )
          ],
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button btn-link",
          attrs: { href: "/admin/person-specifications" }
        },
        [_vm._v("\n        Cancel\n    ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da0b067c", { render: render, staticRenderFns: staticRenderFns })
  }
}